import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Content from "../../common/Content";
import DifficultySelector from "../../ui/DifficultySelector";
import GameArea from "../../ui/GameArea";
import PlayButton from "../../ui/PlayButton";
import OnPositionLevel from "./OnPositionLevel";


const StartingScreen = styled.div`
width: 100%;
height: 100%;
background-image: url(/onposition/starting.png);
background-size: 80%;
background-repeat: no-repeat;
background-position: center;
`;




export default ({ onSetLevel, game }: any) => {
  const { t } = useTranslation("games");
  const [level, setLevel] = useState(1);
  const [started, setStarted] = useState(false);
  const [showCardButton, setShowCardButton] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [restart, setRestart] = useState(0);

  useEffect(() => {
    setStarted(false);
  }, [level]);

  const startGame = () => {
    setStarted(true);
    setShowCardButton(false);
  };

  const showButton = () => {
    setShowCardButton(true);
  }

  const restartGame = () => {
    setGameOver(false);
    setRestart(restart+1);
  }

  return (
    <>
      <GameArea style={{ height: "100%" }} showDetail={!gameOver} game={game}>
         {started ? <OnPositionLevel restart={restart} setShowCardButton={setShowCardButton} gameOver={gameOver} setGameOver={setGameOver} level={level}></OnPositionLevel> : <StartingScreen />}
      </GameArea>

      <Content>
        <div>
          {showCardButton ? (
            <PlayButton onClick={startGame}>Spielkarte einblenden</PlayButton>
          ) : !started ? (
            <PlayButton onClick={showButton} />
          ) : gameOver && <PlayButton onClick={restartGame}>Erneut spielen</PlayButton>
        }
        </div>
        <DifficultySelector
          switchDifficulty={(level) => {
            onSetLevel(level);
            setLevel(level);
          }}
          levels={3}
          current={level}
        />
      </Content>
    </>
  );
};
